import React, { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";
import { ToastAction } from "@/components/ui/toast";
import { useTranslation } from "../../hooks/useTranslation";
import { TenantContext } from "../../contexts/TenantContext";
import { EVENTO_LIMITE } from "../../utils/limitiPiano";

/**
 * In tutte le pagine: quando l'API dice che il piano non comprende quello che
 * si sta facendo (un assistente o una fonte in piu'), un avviso con il motivo
 * e, per chi gestisce l'abbonamento, il pulsante per vedere i piani. Chi non
 * lo gestisce (un collaboratore) sa che deve chiedere al titolare. Non
 * disegna niente: ascolta l'evento del client.
 */
export default function AvvisoLimitePiano() {
  const { t } = useTranslation();
  const { toast } = useToast();
  const navigate = useNavigate();
  // Anche fuori dal provider (es. nei test del layout): senza, niente pulsante.
  const canManageBilling = Boolean(useContext(TenantContext)?.canManageBilling);
  const ultimo = useRef(0);

  useEffect(() => {
    const mostra = (evento) => {
      // Una richiesta che ne fa partire altre (es. il wizard): un avviso solo.
      if (Date.now() - ultimo.current < 3000) return;
      ultimo.current = Date.now();
      toast({
        title: t("billing.limitReachedTitle"),
        description: canManageBilling
          ? evento.detail?.message
          : `${evento.detail?.message || ""} ${t("billing.limitAskOwner")}`.trim(),
        action: canManageBilling ? (
          <ToastAction altText={t("billing.limitSeePlans")} onClick={() => navigate("/billing")}>
            {t("billing.limitSeePlans")}
          </ToastAction>
        ) : undefined,
      });
    };
    window.addEventListener(EVENTO_LIMITE, mostra);
    return () => window.removeEventListener(EVENTO_LIMITE, mostra);
  }, [t, toast, navigate, canManageBilling]);

  return null;
}
